// @flow
import _head from 'lodash/head'
import type {
  SamplingPointOperation,
} from '../types'

// Login Operator
import operator from './operator'

// Constants
import { OPERATION_BRANCH } from 'fc-model-sampling-points'


// Reducers
function addOperation (state: Object, payload: SamplingPointOperation): Object {
  return {
    ...state,
    [OPERATION_BRANCH]: payload,
  }
}

function editOperation (state: Object, payload: SamplingPointOperation): Object {
  return {
    ...state,
    [OPERATION_BRANCH]: _head(payload),
  }
}

function cancelOperation (state: Object): Object {
  return {
    ...state,
    [OPERATION_BRANCH]: null,
  }
}

function updateOperation (state: Object, payload: SamplingPointOperation): Object {
  if (state[OPERATION_BRANCH]) {
    return {
      ...state,
      [OPERATION_BRANCH]: {
        ...payload,
        model: {
          ...state[OPERATION_BRANCH].model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      [OPERATION_BRANCH]: payload,
    }
  }
}

export default {
  ...operator.reducers,
  [operator.actionTypes.add()]: addOperation,
  [operator.actionTypes.edit()]: editOperation,
  [operator.actionTypes.updateOperation()]: updateOperation,
  [operator.actionTypes.cancelOperation()]: cancelOperation,
}
